import { Helmet } from 'react-helmet-async';
import { PageLayout } from '@/components/layout/PageLayout';

export default function AppPrivacyPage() {
  return (
    <PageLayout>
      <Helmet>
        <title>Privacy Policy | Stakeholder Takeover</title>
        <meta name="description" content="Privacy policy for the Stakeholder Takeover Project Brand Search app. No personal information is collected or shared." />
        <meta property="og:title" content="Privacy Policy | Stakeholder Takeover" />
        <meta property="og:description" content="Privacy policy for the Stakeholder Takeover Project Brand Search app. No personal information is collected or shared." />
        <meta property="og:image" content="https://www.stakeholdertakeover.org/android-chrome-512x512.png" />
        <meta property="og:url" content="https://www.stakeholdertakeover.org/app-privacy" />
        <link rel="canonical" href="https://www.stakeholdertakeover.org/app-privacy" />
      </Helmet>
      <div className="container-md">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="h2">Privacy Policy</h1>
            Last Updated: Sep. 21, 2022<br /><br />
            <p>
              The Stakeholder Takeover Project Brand Search app does not collect or share any personal information. All information about brands, companies, emissions, and related information is pre-loaded into the app and stored locally, so the app never contacts any external servers.<br />
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
